var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-radio-group', {
    attrs: {
      "row": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.form.entrance.type,
      callback: function ($$v) {
        _vm.$set(_vm.form.entrance, "type", $$v);
      },
      expression: "form.entrance.type"
    }
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-radio', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })];
  })], 2), _c('v-expand-transition', [_c('v-sheet', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isTypeInterviewees,
      expression: "isTypeInterviewees"
    }]
  }, [_c('v-autocomplete', _vm._b({
    staticStyle: {
      "margin-top": "12px"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form._interviewees,
      callback: function ($$v) {
        _vm.$set(_vm.form, "_interviewees", $$v);
      },
      expression: "form._interviewees"
    }
  }, 'v-autocomplete', _vm.attrs_input, false))], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }